module.exports = __webpack_public_path__ + "assets/img/pp_fc_hl.73f85087.svg";